import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { Box } from '#/components/Box/Box';
import { PrintHidden } from '#/components/PrintHidden/PrintHidden';
import { H5 } from '#/components/Text/H5';
import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

const ToolBox = styled(Box)`
  > *:not(:first-child) {
    margin-left: 12px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      margin-left: 20px;
    }
  }

  button,
  a {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      min-width: 120px;
    }
  }
`;

type Props = {
  message?: ReactNode;
  tools?: ReactNode;
  light?: boolean;
  centered?: boolean;
};

export function PageToolbar({
  message,
  tools,
  light,
  centered,
  ...props
}: Props) {
  return (
    <PrintHidden>
      <Box
        position="relative"
        zIndex={1}
        py="6px"
        px={gutterWidth / 2}
        display={['block', null, 'flex']}
        flexWrap="wrap"
        alignItems="center"
        justifyContent={centered ? 'center' : 'space-between'}
        bg={light ? colors.inputGrey : colors.brandBlue}
        color={light ? colors.brandBlue : 'white'}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flex="0 0 auto"
          pr={centered ? [0, null, 24] : 0}
        >
          {message && (
            <H5 m={0} tag="div" textAlign={['center', null, 'left']}>
              {message}
            </H5>
          )}
        </Box>
        {tools && (
          <ToolBox
            py="6px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flex="0 0 auto"
            mt={[12, null, 0]}
          >
            {tools}
          </ToolBox>
        )}
      </Box>
    </PrintHidden>
  );
}
